import type { ApiClient } from '../api'

export const getStates = async (api: ApiClient) => {
	const path = '/api/states'
	const response = await api.get<StatesResponse>(path)

	return response.data
}

export interface StatesResponse {
	data: {
		states: [string, string, string][]
	}
	message: string
	status: number
}
